import Lang from "../../userPreferences/staticWords";
import * as Yup from "yup";
export const formikValidation = (touched, errors, fieldName) => {
  return touched[fieldName] && errors[fieldName] ? errors[fieldName] : false;
};

export const validationSchema = () => {
  return {
    addNotification: {
      Title: Yup.string().required(Lang.require),
      Description: Yup.string(),
      StartDate: Yup.date(),
      EndDate: Yup.date(),
      SortIndex: Yup.number(),
      Focus: Yup.boolean(),
      NotificationMembers: Yup.array(),
      Members: Yup.array(),
    },
    editNotification: {
      Title: Yup.string().required(Lang.require),
      Description: Yup.string(),
      StartDate: Yup.date().required(Lang.require),
      EndDate: Yup.date().required(Lang.require),
      SortIndex: Yup.number(),
      Focus: Yup.boolean(),
      memberIds: Yup.array(),
    },
  };
};

export const initialValues = (pageData) => {
  return {
    addNotification: {
      Title: "",
      Description: "",
      StartDate: new Date().toISOString().substring(0, 10),
      EndDate: new Date().toISOString().substring(0, 10),
      SortIndex: 0,
      Focus: true,
      NotificationMembers: [],
      Members: [],
    },
    editNotification: {
      Title: pageData?.title_A ?? "",
      Description: pageData?.description_A ?? "",
      StartDate:
        pageData?.startDate ?? new Date().toISOString().substring(0, 10),
      EndDate: pageData?.endDate ?? new Date().toISOString().substring(0, 10),
      SortIndex: pageData?.sortIndex ?? 0,
      Focus: pageData?.focus ?? true,
      memberIds: pageData?.memberIds ?? [],
    },
  };
};

export const formikSetup = (
  initialValues,
  sourceOfIntailData,
  validationSchema,
  pageName,
  submitFunction
) => {
  return {
    initialValues: {
      ...initialValues(sourceOfIntailData)[pageName],
    },
    validationSchema: Yup.object({ ...validationSchema(Yup)[pageName] }),
    onSubmit: submitFunction,
  };
};
